import React, { useContext } from "react";
import { Column, Columns, Logo } from "@dna/react";
import { RenderIf } from "../common/render-if/RenderIf";
import { Box, Button, IconButton, makeStyles, Menu } from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import {
  ArrowDownIcon,
  ArrowUpIcon,
} from "@communicare/medications/Components/Icons";
import { SelectOrganisationDialogBox } from "../common/dialogbox/SelectOrganisationDialogBox";
import { IdentityContext } from "../auth/UserIdentity";
import logoImage from "../../images/TH-green-L3.png";
import { handleSignOut } from "../common/handleSignOut";
import { getFromStorage } from "../../config/auth.config";
import { LinkAdditionalOrganisationDialogBox } from "../common/dialogbox/LinkAdditionalOrganisationDialogBox";
import { isNullOrUndefined } from "util";
import { isNullOrUndefinedOrEmptyString } from "../common/utils/util";

let iconpack = require("@dna/icons");

const useStyles = makeStyles({
  profileButton: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#FFFFFF",
    textTransform: "none",
    height: "48px",
    "&:hover": {
      backgroundColor: "#025450",
    },
  },

  profileButtonClicked: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#FFFFFF",
    backgroundColor: "#025450",
    textTransform: "none",
    height: "48px",
  },

  menu: {
    "&.MuiPaper-root-39": {
      backgroundColor: "#0064D2",
      border: "1px solid #D8D8D8",
      boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.25)",
    },
  },

  menuItem: {
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "30px",
    color: "#0064D2",
    "&:hover": {
      backgroundColor: "#D8D8D8",
    },
  },

  box: {
    backgroundColor: "#00AD4F",
    width: "30px",
    height: "30px",
    marginRight: "13px",
    fontWeight: 600,
    fontSize: "18px",
    lineHeight: "30px"
  },

  productName: {
    fontFamily: "TelstraGravur",
    fontSize: "20px",
    color: "#fff",
    borderLeft: "1px solid #fff",
    paddingTop: "6px",
    paddingBottom: "5px",
    paddingLeft: "12px",
  },

  logo: {
    height: "30px",
    width: "70px",
    verticalAlign: "bottom",
    marginTop: "10px",
    marginRight: "12px",
    marginLeft: "25px",
  },
});

export function HeaderBar() {
  let ctx = useContext(IdentityContext);
  let userName = ctx?.userInfo?.userName;
  let isOnadditionalDetailsPage = (ctx?.userInfo?.isShared && !getFromStorage('providerId'));
  let userFullName = '';
  let shortUserName = '';
  if (!isNullOrUndefinedOrEmptyString(ctx?.userInfo?.givenName) && !isNullOrUndefinedOrEmptyString(ctx?.userInfo?.familyName)) {
    userFullName = ctx?.userInfo?.givenName + " " + ctx?.userInfo?.familyName;

    shortUserName =
      ctx?.userInfo?.givenName?.charAt(0).toUpperCase() +
      "" +
      ctx?.userInfo?.familyName?.charAt(0).toUpperCase();
  }

  const logOut = () => {
    handleSignOut({reason: "Headerbar logout", url: window.location.href})
  };


  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [showDialog, setshowDialog] = React.useState(false);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    setshowDialog(false);
  };

  const handleAnotherProvider = () => {
    setshowDialog(true);
    setAnchorEl(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setshowDialog(false);
  };

  let classes = useStyles();
  return (
    <Columns
      css={{
        backgroundColor: "primary",
        height: "48px"
      }}
    >
      <Column width="3/5">
        <img className={classes.logo} src={logoImage}></img>
        <span className={classes.productName}>MEDPOINT</span>
      </Column>

      <Column width="2/5">
        <RenderIf if={!!ctx?.userInfo && !!userName && !isOnadditionalDetailsPage && !isNullOrUndefinedOrEmptyString(userFullName)}>
          <>
            <Button
              aria-controls="user-menu"
              aria-haspopup="true"
              onClick={handleClick}
              className={
                anchorEl ? classes.profileButtonClicked : classes.profileButton
              }
              style={{ float: "right", marginRight: "10px" }}
            >
              <Box className={classes.box}>{shortUserName}</Box>

              {userFullName}
              <IconButton
                aria-label="close"
                style={{ marginLeft: "-10px", fontWeight: 600 }}
                onClick={handleClose}
                disableRipple
              >
                {anchorEl ? (
                  <ArrowUpIcon color="white" />
                ) : (
                  <ArrowDownIcon color="white" />
                )}
              </IconButton>
            </Button>

            <Menu
              id="user-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
              getContentAnchorEl={null}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              PaperProps={{
                style: {
                  backgroundColor: "#F7F7F7",
                  width: "280px",
                },
              }}
            >
              <MenuItem
                onClick={handleAnotherProvider}
                className={classes.menuItem}
              >
                Link to another aged care provider
              </MenuItem>
              <MenuItem onClick={logOut} className={classes.menuItem}>
                Sign out
              </MenuItem>
            </Menu>
             <LinkAdditionalOrganisationDialogBox
              open={showDialog}
            />
          </>
        </RenderIf>
      </Column>
    </Columns>
  );
}
